/**
 * @file JS - Controller - LeftMenuController.js
 * @author Adam Lemire
 * @since 2020/08/24
 * @version 1.0
 * @summary Dernières modifications : 2023/03/02
 */

import { GisButton, GisSection } from './../helpers/Selectors.js';

/** Controlleur des boutons du menu gauche */
export default class LeftMenuController {
  static écouterBoutonsMenuGauche () {
    $(GisButton.GIS_LEFT_MENU).off().on('click tap', () => basculerVisibilitéDétails());
  }

  static afficherCouchesDeCarteActive () {
    if (!$(GisSection.LEFT_MENU).hasClass('stretched')) {
      afficherDétails();
    }
    $(GisSection.LEFT_MENU_DETAIL).addClass('hidden');
    $(GisSection.MAP_LAYERS).removeClass('hidden');
    $(GisButton.GIS_LEFT_MENU_BUTTONS).removeClass('active');
    $(GisButton.GIS_MAP_LAYER).addClass('active');
  }

  static afficherCouchesWeb () {
    if (!$(GisSection.LEFT_MENU).hasClass('stretched')) {
      afficherDétails();
    }
    $(GisSection.LEFT_MENU_DETAIL).addClass('hidden');
    $(GisSection.WEB_LAYERS).removeClass('hidden');
    $(GisButton.GIS_LEFT_MENU_BUTTONS).removeClass('active');
    $(GisButton.GIS_WEB_LAYER).addClass('active');
  }

  static afficherDétailsPageCartesMultiples () {
    if (!$(GisSection.LEFT_MENU).hasClass('stretched')) {
      afficherDétails();
    }
    $(GisSection.LEFT_MENU_DETAIL).addClass('hidden');
    $(GisSection.MULTI_MAP_DETAILS).removeClass('hidden');
    $(GisButton.GIS_LEFT_MENU_BUTTONS).removeClass('active');
    $(GisButton.GIS_MULTI_MAPS).addClass('active');
  }

  static afficherOptionsMiseEnForme () {
    if (!$(GisSection.LEFT_MENU).hasClass('stretched')) {
      afficherDétails();
    }
    $(GisSection.LEFT_MENU_DETAIL).addClass('hidden');
    $(GisSection.PRINT_LAYOUT_OPTIONS).removeClass('hidden');
    $(GisButton.GIS_LEFT_MENU_BUTTONS).removeClass('active');
    $(GisButton.GIS_PRINT_LAYOUT).addClass('active');
  }
}

function cacherDétails () {
  $(GisSection.LEFT_MENU).removeClass('stretched');
  $(GisSection.LEFT_MENU_DETAILS).addClass('hidden');
  $(GisSection.CONTENT).removeClass('shrinked').trigger('classChange');
}

function afficherDétails () {
  $(GisSection.LEFT_MENU).addClass('stretched');
  $(GisSection.LEFT_MENU_DETAILS).removeClass('hidden');
  $(GisSection.CONTENT).addClass('shrinked').trigger('classChange');
}

function basculerVisibilitéDétails () {
  if ($(GisSection.LEFT_MENU).hasClass('stretched')) {
    cacherDétails();
  } else {
    afficherDétails();
  }
}
